import Vue from 'vue'
import { ToastPlugin, ModalPlugin, TooltipPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import userRoleMixin from '@/mixins/userRoleMixin'
import VueInputAutowidth from 'vue-input-autowidth'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

import '@axios'

import './filters'

Vue.mixin(userRoleMixin)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(TooltipPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// Vue Input Autowidth
Vue.use(VueInputAutowidth)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
